import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';

window.addEventListener('vite:preloadError', () => {
  const lastReload = sessionStorage.getItem('chunk-reload');
  const now = Date.now().toString();
  if (!lastReload || Date.now() - Number(lastReload) > 10000) {
    sessionStorage.setItem('chunk-reload', now);
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);
